import BookingDateInput from './BookingDateInput';
const BOOKING_DATE_SELECTOR = '[data-booking-date]';
import BookingTimeInput from './BookingTimeInput';

class DateInputInitializer {
  constructor() {
    new BookingTimeInput('body');

    this.inputs = $(BOOKING_DATE_SELECTOR);
    if (this.inputs.length == 0) {
      return false;
    }

    $.each(this.inputs, (idx, elem) => {
      new BookingDateInput($(elem));
    });

    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      $.each($($addedTask).find(BOOKING_DATE_SELECTOR), (idx, elem) => {
        new BookingDateInput($(elem));
      });
    });
  }
}

export default DateInputInitializer;



// WEBPACK FOOTER //
// ./src/javascripts/DateInputInitializer.js